( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( "LotImportModalController", LotImportModalController );

    LotImportModalController.$inject = [ '$uibModalInstance', 'ToastrService', 'LotCustomService', 'ShipmentCustomService', 'Contract', 'Principal',
                                    'contractEntity', 'contractBEntity', 'contractCEntity', 'contractDEntity', 'contractEEntity', 'contractFEntity', 'siEntity', 'saleContractEntity'];

    function LotImportModalController( $uibModalInstance, ToastrService, LotCustomService, ShipmentCustomService, Contract, Principal,
                                       contractEntity, contractBEntity, contractCEntity, contractDEntity, contractEEntity, contractFEntity, siEntity, saleContractEntity ) {
        var vm = this;

        vm.showPContractDetails = false;
        vm.showPurchSiInput = false;
        vm.showPurchSiDetails = false;
        vm.wtUnitTypes = ['KG', 'LB', 'MT'];
        vm.wtUnitType = vm.wtUnitTypes[0];
        vm.separators = ['Point', 'Comma'];
        vm.separator = vm.separators[0];

        vm.shipment = siEntity;
        vm.saleContract = saleContractEntity;

        //ng-click functions
        vm.submit = submit;
        vm.cancel = cancel;
        vm.openCalendar = openCalendar;
        vm.fetchContracts = fetchContracts;
        vm.applyPurchaseContractStuff = applyPurchaseContractStuff;

        //submit function
        function submit() {
            vm.hot.data.forEach( function( element) {
                if( Object.keys( element ).length == 13 ) {
                    buildLot( element );
                }
            });
            if( vm.shipment.id != null ) {
                LotCustomService.assignShipmentToLots( vm.lots, vm.shipment ).then( function( result ) {
                    ToastrService.success( "Successfully allocated Lots to shipment", "Success!" );
                    $uibModalInstance.close( result.data );
                }, function( error ) {
                    if( error.status !== "404" ) {
                        ToastrService.error( error.message, "Error");
                    }
                    console.log( error.message );
                });
            } else {
                ToastrService.info( "Added imported lots to Shipment", "Success!" );
                $uibModalInstance.close( vm.lots );
            }
        }

        //cancel function
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        //qty unit types
        vm.qtyUnitTypes = [];
        vm.qtyUnitTypes.push( vm.shipment.qtyUnitType );
        vm.qtyUnitType = vm.shipment.qtyUnitType;

        //lot status
        vm.lotStatuses = ['ALLOCATED'];
        vm.lotStatus = "ALLOCATED";

        //date picker stuff
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        //array to hold imported lots
        vm.lots = [];

        //lot extra details
        vm.loadingPeriod = null;
        vm.loadingPlace = null;
        vm.loadingWarehouse = null;
        vm.lotWeightDisplay = null;

        if( vm.shipment.id != null ) {
            vm.purchSi = vm.shipment;
            vm.allocSi = vm.shipment;
            vm.allocSale = vm.saleContract;
        } else {
            vm.purchSi = null;
            vm.allocSi = null;
            vm.allocSale = null;
        }

        //=======================================================
        //Purchase Contract Details Tab
        //=======================================================
        //fetch purchase contracts
        vm.purchContracts = [];
        fetchContracts();

        function fetchContracts() {
            vm.purchContracts.length = 0;
            if( contractEntity ) {
                vm.purchContracts.push( contractEntity );
            }
            if( contractBEntity ) {
                vm.purchContracts.push( contractBEntity );
            }
            if( contractCEntity ) {
                vm.purchContracts.push( contractCEntity );
            }
            if(contractDEntity) {
                vm.purchContracts.push(contractDEntity);
            }
            if(contractEEntity) {
                vm.purchContracts.push(contractEEntity);
            }
            if(contractFEntity) {
                vm.purchContracts.push(contractFEntity);
            }
            if( vm.purchContracts.length === 1 ) {
                vm.purchaseContract = vm.purchContracts[0];
                applyPurchaseContractStuff();
            }
        }

        vm.activateLotStatus = activateLotStatus;
        vm.activateQtyUnitType = activateQtyUnitType;
        vm.activateWtUnitType = activateWtUnitType;
        vm.activateSeparator = activateSeparator;

        function activateLotStatus( option ) {
            vm.lotStatus = option;
        };

        function activateQtyUnitType( option ) {
            vm.qtyUnitType = option;
        };

        function activateWtUnitType( option ) {
            vm.wtUnitType = option;
        }

        function activateSeparator( option ) {
            vm.separator = option;
        }

        //open calendar
        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        //place holders for purchase contract stuff
        vm.growth = null;
        vm.seller = null;
        vm.cropYear = null;
        vm.purchPriceUnit = null;
        vm.purchPrice = 0;
        vm.purchWtType = null;

        function applyPurchaseContractStuff() {
            if( vm.purchaseContract !== null ) {
                vm.showPContractDetails = true;
                vm.cropYear = vm.purchaseContract.cropYear;
                vm.seller = vm.purchaseContract.seller.name;
                vm.growth = vm.purchaseContract.growth.location;
            } else {
                vm.showPContractDetails = false;
                vm.cropYear = null;
                vm.seller = null;
                vm.growth = null;
            }
        };

        //=======================================================
        //Lots To Import Tab
        //=======================================================
        //hot table settings
        vm.hot = {
            settings: { colHeaders: true, contextMenu: [ 'row_above', 'row_below', 'remove_row' ] },
            rowHeaders: true,
            minSpareRows: 1,
            data: []
        };

        //resolve weight display
        function resolveWeightDisplay( weight ) {
            return weight + " " + vm.wtUnitType;
        }

        //compute for other weights
        function resolveWeights( weight, lot ) {
            var newWeight = periodsOrCommas( weight );
            var lbs = 0;
            var kgs = 0;
            var mts = 0;
            var avg = Math.round( ( newWeight / lot.qtyBales ) * 100 ) / 100;
            // switch( vm.qtyUnitType ) {
            switch( vm.wtUnitType ) {
                case 'LB':
                    lbs = newWeight;
                    kgs = Math.round( ( newWeight / 2.2046 ) * 100 ) / 100;
                    mts = Math.round( ( kgs / 1000 ) * 100 ) / 100;
                    break;
                case 'KG':
                    kgs = newWeight;
                    lbs = Math.round( ( kgs * 2.2046 ) * 100 ) / 100;
                    mts = Math.round( ( kgs / 1000 ) * 100 ) / 100;
                    break;
                case 'MT':
                    mts = newWeight;
                    kgs = Math.round( ( mts * 1000 ) * 100 ) / 100;
                    lbs = Math.round( ( kgs * 2.2046 ) * 100 ) / 100;
                    break;
            }
            //apply calculated weights to lot
            lot['lotWeightLbs'] = lbs;
            lot['lotWeightKgs'] = kgs;
            lot['lotWeightMts'] = mts;
            //actual weights
            lot['purchGrossLbs'] = lbs;
            lot['purchNetLbs'] = lbs;
            lot['purchTareLbs'] = 0;
            lot['purchGrossKgs'] = kgs;
            lot['purchNetKgs'] = kgs;
            lot['purchTareKgs'] = 0;
            lot['purchGrossMTs'] = mts;
            lot['purchNetMTs'] = mts;
            lot['purchTareMTs'] = 0;
            //landed weights
            lot['purchLandedGrossLbs'] = lbs;
            lot['purchLandedNetLbs'] = lbs;
            lot['purchLandedTareLbs'] = 0;
            lot['purchLandedGrossKgs'] = kgs;
            lot['purchLandedNetKgs'] = kgs;
            lot['purchLandedTareKgs'] = 0;
            lot['purchLandedGrossMTs'] = mts;
            lot['purchLandedNetMTs'] = mts;
            lot['purchLandedTareMTs'] = 0;
            //avg weights
            lot['actualWtAvg'] = avg;
            lot['actualWtGrossAvg'] = avg;
            lot['actualWtTareAvg'] = 0;
            lot['landedWtAvg'] = avg;
            lot['landedWtGrossAvg'] = avg;
            lot['landedWtTareAvg'] = 0;
            return lot;
        }

        function periodsOrCommas( myNumber ) {
            if( vm.separator === "Point" ) {
                return mathRoundIgnoreCommas( myNumber );
            } else {
                return mathRoundConvertCommasToDecimal( myNumber );
            }
        }

        //remove commas on weight string and convert to number
        function mathRoundIgnoreCommas( myNumber ) {
            var numberNoCommas = myNumber.replace(/,/g, '');
            return Math.round( numberNoCommas * 100 ) / 100;
        }

        //in case commas are used as decimal places. this will convert the commas to decimal points
        function mathRoundConvertCommasToDecimal( myNumber ) {
            var numberConvertCommas = myNumber.replace(/,/g, '.');
            return Math.round( numberConvertCommas * 1000 ) / 1000;
        }

        //build Lot
        function buildLot( element ) {
            var lot = {
                //given values
                id: null,
                createdOn: new Date(),
                createdBy: "user",
                modifiedOn: new Date(),
                modifiedBy: "user",
                lotStatus: vm.lotStatus,
                qtyUnitType: vm.qtyUnitType,
                cropYear: vm.cropYear,
                growth: vm.growth,
                loadingPeriod: vm.loadingPeriod,
                loadingPlace: vm.loadingPlace,
                loadingWarehouse: vm.loadingWarehouse,
                takeUpNr: vm.takeUpNr,
                loadingDate: vm.date,
                seller: vm.seller,
                placeOfTakeUp: vm.placeOfTakeUp,
                ginRef: element.ginRef,
                origin: element.origin,
                producer: element.producer,
                lotRef: element.lotRef,
                qtyBales: element.qtyBales,
                lotType: element.lotType,
                lotWeightDisplay: resolveWeightDisplay( element.lotWeightDisplay ),
                lotMic: element.lotMic,
                lotLen: element.lotLen,
                lotStr: element.lotStr,
                lotRdb: element.lotRdb,
                lotSfi: element.lotSfi,
                farmRef: element.farmRef,
                imported: true,
                //default purch stuff values
                purchase: vm.purchaseContract,
                purchSi: vm.purchSi,
                purchPriceUnit: null,
                purchPrice: 0,
                purchWtType: vm.wtUnitType,
                purchValue: 0,
                //default inter stuff values
                interPrice: 0,
                interGrossKgs: 0,
                interNetKgs: 0,
                interTareKgs: 0,
                interGrossLbs: 0,
                interNetLbs: 0,
                interTareLbs: 0,
                interGrossMTs: 0,
                interNetMTs: 0,
                interTareMTs: 0,
                interLandedGrossKgs: 0,
                interLandedNetKgs: 0,
                interLandedTareKgs: 0,
                interLandedGrossLbs: 0,
                interLandedNetLbs: 0,
                interLandedTareLbs: 0,
                interLandedGrossMTs: 0,
                interLandedNetMTs: 0,
                interLandedTareMTs: 0,
                interValue: 0,
                //default sale stuff values
                allocSale: vm.allocSale,
                allocSi: vm.allocSi,
                salePriceUnit: null,
                salePrice: 0,
                saleFinalPrice: 0,
                saleWtType: vm.wtUnitType,
                saleGrossKgs: 0,
                saleNetKgs: 0,
                saleTareKgs: 0,
                saleGrossLbs: 0,
                saleNetLbs: 0,
                saleTareLbs: 0,
                saleGrossMTs: 0,
                saleNetMTs: 0,
                saleTareMTs: 0,
                saleLandedGrossKgs: 0,
                saleLandedNetKgs: 0,
                saleLandedTareKgs: 0,
                saleLandedGrossLbs: 0,
                saleLandedNetLbs: 0,
                saleLandedTareLbs: 0,
                saleLandedGrossMTs: 0,
                saleLandedNetMTs: 0,
                saleLandedTareMTs: 0,
                saleValue: 0,
                landedValue: 0,
                invoiceValue: 0
            }
            vm.lots.push( resolveWeights( element.lotWeightDisplay, lot ) );
        }

    }
})();
